import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl, ReactiveFormsModule } from '@angular/forms';
import { MustMatch } from '../../../../Shared/functions/match-validator';
import { CommonModule } from '@angular/common';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.scss'],
  imports: [CommonModule, ReactiveFormsModule, RecaptchaModule, RecaptchaFormsModule]
})
export class PasswordComponent implements OnInit {

  @Input() public showForm: boolean;
  @Input() public parentForm: FormGroup;
  public form: FormGroup;

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      password: ['', [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&]).{8,}')]],
      confirm: ['', [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&]).{8,}')]],
      accept: [false, Validators.requiredTrue],
      recaptcha: [null, Validators.required]
    }, {validators: MustMatch('password', 'confirm')});

    this.parentForm.addControl('passwordGroup', this.form);
  }
}
